import React from 'react';

const AnnotatedText = ({ annotation, text, onSelect, isSelected }) => {
  const getClassName = () => {
    const classes = ['annotated-text'];
    classes.push(`type-${annotation.type}`);
    classes.push(`severity-${annotation.severity}`);
    classes.push(`category-${annotation.category}`);
    if (isSelected) classes.push('selected');
    return classes.join(' ');
  };

  const renderContent = () => {
    if (annotation.type === 'inline_edit' && annotation.suggestedText) {
      return (
        <>
          <span className="original-text">{text}</span>
          <span className="suggested-text">{annotation.suggestedText}</span>
        </>
      );
    }
    return text;
  };

  // Calculate a display index for margin comments (1-based for better UX)
  const getMarginIndicator = () => {
    // Use a comment bubble icon or asterisk instead of the ID
    return '💬';
  };

  return (
    <span 
      className={getClassName()}
      onClick={onSelect}
      title={`${annotation.category.toUpperCase()}: ${annotation.feedback}`}
      data-annotation-id={annotation.id}
    >
      {renderContent()}
      {annotation.type === 'margin_comment' && (
        <span 
          className="margin-indicator" 
          style={{
            fontSize: '0.8rem',
            verticalAlign: 'super',
            marginLeft: '2px',
            cursor: 'pointer'
          }}
        >
          {getMarginIndicator()}
        </span>
      )}
    </span>
  );
};

export default AnnotatedText;